/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Enrolled_SuccessInputs */

const fr_totp_enrolled_success = /** @type {(inputs: Totp_Enrolled_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'authentification à deux facteurs a été activée`)
};

/**

* @param {Totp_Enrolled_SuccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_enrolled_success = /** @type {((inputs?: Totp_Enrolled_SuccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Enrolled_SuccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_enrolled_success(inputs)
});